import themeConfig from "@root/theme.config";
export function useColors() {
    const colors = themeConfig.theme.colors;

    const getColorValue = (colorName) => {
        return colors[colorName];
    };

    return {
        colors,
        getColorValue
    };
}
